<template>
    <span v-if="config.title" v-popover:tooltip="t(getTitle())">{{ getName() }}</span>
    <span v-else>{{ getName() }}</span>
</template>

<script>

export default {
    props: {
        config: {
            type: Object,
            default: function() {
                return {
                    name: null,
                    title: null,
                    i18nParams: null
                }
            },
        },
    },
    data() {
        return {

        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        getName() {
            return this.$trans(this.config.name, this.config.i18nParams);
        },
        getTitle() {
            return this.$trans(this.config.title, this.config.i18nParams);
        }
    }
}

</script>

<style scoped lang="sass">

</style>


// WEBPACK FOOTER //
// DefaultHeaderComponent.vue?00a64684